import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import {
  IonModal,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonText,
} from "@ionic/react";
import "./ModalActualizarContrasena.css";
import LoadingBackdrop from "../../basicsComponents/LoadingBackdrop/LoadingBackdrop";

const ModalActualizarContrasenia = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showModal, setShowModal] = useState(!!token); // Mostrar el modal solo si hay un token
  const [errorMessage, setErrorMessage] = useState("");
  const [cargando, setCargando] = useState(false);

  // Limpiar error y cargando al abrir el modal
  useEffect(() => {
    if (showModal) {
      setErrorMessage("");
      setCargando(false);
      setNewPassword("");
      setConfirmPassword("");
    }
  }, [showModal]);
  const history = useHistory();
  const [urlAxioPP, setUrlAxio] = useState("");

  useEffect(() => {
    setUrlAxio(localStorage.getItem("urlAxioPP"));
  }, []);

  const handlePasswordUpdate = async () => {
    setCargando(true);

    if (newPassword !== confirmPassword) {
      setCargando(false);
      alert(
        "Para una doble verificación, revise nuevamente su contraseña. Si es correcta y cumple con los requisitos, haga click en 'Actualizar'");
      return;
    }

    const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{4,20}$/;
    if (!passwordRegex.test(newPassword)) {
      setErrorMessage(
        "La contraseña debe tener entre 4 y 20 caracteres alfanuméricos, al menos una letra mayúscula y al menos un número."
      );
      setCargando(false);
      return; // Detener la ejecución si la contraseña no cumple con las restricciones
    }

    try {
      const response = await axios.post(
        `${urlAxioPP}/Usuarios/ActualizarContrasenia`.replace(
          /([^:]\/)\/+/g,
          "$1"
        ),
        {
          Token: token,
          NuevoPassword: newPassword,
        }
      );
      console.log(response.data);

      if (response.status === 200) {
        setCargando(false);
        alert("Contraseña actualizada correctamente.");
        setShowModal(false);
        history.push("/Login"); // Redirige al login después de cambiar la contraseña
      } else {
        setCargando(false);
      }
    } catch (error) {
      setCargando(false);
      console.error("Error actualizando la contraseña:", error);
      alert("Error en la actualización de la contraseña. Intente nuevamente.");
    }
  };

  if (!token) {
    return null;
  }

  return (
    <IonModal isOpen={showModal} cssClass="custom-modal">
      <div style={{ padding: "20px", position: "relative" }}>
  {/* Spinner eliminado */}
        <h2>Actualizar Contraseña</h2>
        <IonText color="medium">
          <p>
            La contraseña debe tener entre 4 y 20 caracteres alfanuméricos y al
            menos una letra mayúscula y un número.
          </p>
        </IonText>
        <IonItem>
          <IonLabel position="stacked">Nueva Contraseña</IonLabel>
          <IonInput
            type="text"
            value={newPassword}
            onIonChange={(e) => {
              let value = e.detail.value || '';
              value = value.replace(/\s+/g, '');
              setNewPassword(value);
            }}
          />
        </IonItem>
        <IonItem>
          <IonLabel position="stacked">Confirmar Contraseña</IonLabel>
          <IonInput
            type="text"
            value={confirmPassword}
            onIonChange={(e) => {
              let value = e.detail.value || '';
              value = value.replace(/\s+/g, '');
              setConfirmPassword(value);
            }}
          />
        </IonItem>
        {errorMessage && <IonText color="danger">{errorMessage}</IonText>}
        <br />
        <IonButton onClick={handlePasswordUpdate} color="success" disabled={cargando}>
          Actualizar
        </IonButton>
        <IonButton onClick={() => setShowModal(false)} color="danger" disabled={cargando}>
          Cancelar
        </IonButton>
      </div>
    </IonModal>
  );
};

export default ModalActualizarContrasenia;


